import React from 'react';

interface DisableSelectedOwnProps {
  isSelected: boolean;
}

interface DisableSelectedDispatchProps {
  disableSelected: () => void;
}

type DisableSelectedProps = DisableSelectedOwnProps & DisableSelectedDispatchProps;

export const DisableSelectedComponent: React.FC<DisableSelectedProps> = ({ isSelected, disableSelected }) => (
  <label className={`role-btn role-off ${!isSelected && 'disabled'}`}>
    <input type="radio" value="off" disabled={!isSelected} onClick={disableSelected} />
    {t('label.off')}
  </label>
);
